import { createIcon } from '@chakra-ui/icons';

export const LinkIcon = createIcon({
  displayName: 'LinkIcon',
  viewBox: '0 0 32 32',
  path: [
    <path
      key="1"
      d="M13.4734 8.41999L18.526 3.36736C18.526 3.36736 23.5787 -1.68527 28.6313 3.36736C33.6839 8.41999 28.6313 13.4726 28.6313 13.4726L21.8945 20.2095C21.8945 20.2095 16.8418 25.2621 11.7892 20.2095C10.8418 19.2621 10.2549 18.0031 10.2549 18.0031L13.0785 15.1838C13.0785 15.1838 12.9648 16.3324 14.3155 17.6831C14.3155 17.6831 16.8418 20.2095 19.3681 17.6831L26.105 10.9463C26.105 10.9463 28.6313 8.41999 26.105 5.89367C23.5787 3.36736 21.0524 5.89367 21.0524 5.89367L17.9121 9.03389C17.9121 9.03389 16.3509 7.75304 13.1576 8.73578L13.4734 8.41999Z"
      fill="#8899A6"
    />,
    <path
      key="2"
      d="M18.3957 23.5787L13.3431 28.6313C13.3431 28.6313 8.29043 33.684 3.2378 28.6313C-1.81483 23.5787 3.2378 18.5261 3.2378 18.5261L9.97464 11.7892C9.97464 11.7892 15.0273 6.7366 20.0799 11.7892C21.0273 12.7366 21.6142 13.9955 21.6142 13.9955L18.7906 16.8158C18.7906 16.8158 18.9043 15.6663 17.5536 14.3155C17.5536 14.3155 15.0273 11.7892 12.501 14.3155L5.76412 21.0524C5.76412 21.0524 3.2378 23.5787 5.76412 26.105C8.29043 28.6313 10.8167 26.105 10.8167 26.105L13.957 22.9648C13.957 22.9648 15.5182 24.2448 18.7115 23.2629L18.3957 23.5787Z"
      fill="#8899A6"
    />,
  ],
});
